import { IntegrationType, ServiceAccount } from '@/iam/types';
import api from '@/iam/API';
import serviceAccountRepository from '@/iam/integration/service-account/service-account-repository';

export async function createServiceAccount(
  accountId: number,
  integrationType: IntegrationType,
): Promise<ServiceAccount> {
  const existing = await serviceAccountRepository.findByIntegrationType(accountId, integrationType);
  if (existing) return existing;
  const endpoint = `accounts/${accountId}/service-accounts/integrations`;
  return api
    .post(endpoint, { integrationType })
    .then(response => response.data);
}
